var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$_.isEmpty(_vm.order))?_c('loading'):_c('invoices-listing',{attrs:{"contract-id":_vm.order.contract_id,"client-id":_vm.order.client_id}})}
var staticRenderFns = []

export { render, staticRenderFns }